import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=2fa1fadc&scoped=true&"
import script from "./explain.vue?vue&type=script&lang=ts&"
export * from "./explain.vue?vue&type=script&lang=ts&"
import style0 from "./explain.vue?vue&type=style&index=0&id=2fa1fadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1fadc",
  null
  
)

export default component.exports